export const salutationOptions = ['Mr.', 'Ms.', 'Mrs.', 'Dr.', 'Prof.'];
export const genderOptions = ['Male', 'Female', 'Other'];
export const leadTypeOptions = ['Programme Enquiry', 'Attend Programme Seminar', 'Other Enquiry'];
export const leadSourceOptions = ['Email', 'Phone Call', 'Enquiry Form', 'Other'];
export const leadStatusOptions = ['Unhandled', 'Handling', 'Completed', 'Dead'];
export const channelStatusOptions = ['About to Active', 'Active', 'Expired', 'Inactive'];
export const customerQualificationOptions = ['Non-degree', 'Degree', 'Master or Above'];
export const customerWorkExperienceOptions = ['Below 3 yrs', '3 - 5 yrs', '5 yrs or Above'];


// WEBPACK FOOTER //
// ./src/utils/options.js